import { ListWrapper } from '@sahinyazilim/sahinyazilim-components';
import { accountActions } from 'account/common/context/AccountSlice';
import { AccountRouteNames } from 'account/common/model/AccountRouteNames';
import { plans } from 'account/plan/helper/Plans.data';
import { sahinAlertDialog } from 'common/components/AlertDialog/AlertDialog';
import { Plans } from 'common/components/LandingComponents/Plans';
import { useAppDispatch, useAppSelector } from 'common/context/hooks';
import { createLink } from 'common/helper/createRoute';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export const PlanList = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const currentPlan = useAppSelector((state) => state.common.currentPlan);
  const currentOrder = plans.find((plan) => plan.id === currentPlan?.plan.id);

  const onSelectHandle = (selected: any, index: number, isYearly: boolean) => {
    if (selected.order === 1) {
      sahinAlertDialog({
        message:
          'Ücretsiz plan satın alınamaz. Aktif planınızın süresi bittiğinde sistem otomatik olarak ücretsiz plana geçiş yapacaktır.',
        type: 'warning',
        duration: 10000,
      });
      return;
    }

    if (selected.order <= (currentOrder?.order || 0)) {
      sahinAlertDialog({
        message:
          'Alt bir pakete geçiş yapamazsınız. Aktif planınızın süresi bittiğinde sistem otomatik olarak ücretsiz plana geçiş yapacaktır.',
        type: 'warning',
        duration: 10000,
      });
      return;
    }
    dispatch(accountActions.selectPlan({ ...selected, index, isYearly }));
    navigate(createLink(AccountRouteNames, AccountRouteNames.PAYMENT));
  };

  return (
    <ListWrapper title={t('account.selectPlan')}>
      <Plans onSelect={onSelectHandle} isYearlyPrice />
    </ListWrapper>
  );
};
